import { Check, Download } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

/** Opens a stand-in for the BOR e-sign dialog; signing marks the step done. */
export function SignFormsStep({ carrierName, onSigned }: { carrierName: string; onSigned: () => void }) {
  const [isOpen, setIsOpen] = useState(false)
  const [isSigned, setIsSigned] = useState(false)

  if (isSigned) {
    return (
      <div className="mt-3 flex flex-col items-start gap-3">
        <span className="flex items-center gap-1 font-semibold text-green-600">
          <Check className="size-4" /> Signed
        </span>
        <p className="text-ink-500 text-sm lg:max-w-[400px]">
          Your signed documents have been added to the Documents tab in your account.
        </p>
        <Button variant="outline" size="sm">
          <Download />
          Download forms
        </Button>
      </div>
    )
  }

  return (
    <>
      <Button className="mt-3" onClick={() => setIsOpen(true)}>
        Sign
      </Button>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent size="full" className="h-[calc(100vh-40px)] max-h-[calc(100vh-40px)] content-stretch">
          <div className="flex h-full flex-col">
            <DialogTitle className="mb-4 text-center">Sign your {carrierName} forms</DialogTitle>
            {/* Mock: the real dialog embeds the e-sign envelope here. */}
            <div className="border-ink-200 bg-surface flex flex-1 flex-col items-center justify-center gap-4 rounded-sm border">
              <p className="text-md text-ink-500">Your {carrierName} forms load here.</p>
              <Button
                onClick={() => {
                  setIsOpen(false)
                  setIsSigned(true)
                  onSigned()
                }}
              >
                Sign
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
